import React, { useState } from "react";
import "style/PlanItems.scss";

import Tooltip from "@mui/material/Tooltip";

import Reveal from "components/Reveal";
import ui from "config/i18n/ui";
import { resolveLang } from "hooks/useLang";

import { default as SvgPlanItemTrue } from "assets/SvgPlanItemTrue.svg";
import { default as SvgPlanItemFalse } from "assets/SvgPlanItemFalse.svg";
import { default as SvgInformation } from "assets/SvgInformation.svg";

interface FeatureMeta {
  id: string;
  description: string;
  info: string;
}

interface Props {
  name: string;
  description: string;
  provides: string[];
  cost_ones: string;
  cost_monthly: string;
  on_sale: string;
  trialUrl: string;
  planDescription: FeatureMeta[];
  planInfoText: string[];
  featured?: boolean;
  delay?: number;
}

const PlanItems: React.FC<Props> = ({
  name,
  description,
  provides,
  cost_ones,
  cost_monthly,
  on_sale,
  trialUrl,
  planDescription,
  planInfoText,
  featured,
  delay,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Reveal className="plan-cell" delay={delay}>
      <article className={`plan-card${featured ? " plan-card--featured" : ""}`}>
        <header className="plan-card__head">
          <h3>{name}</h3>
          <p>{description}</p>
        </header>

        <div className="plan-card__price">
          <div className="plan-card__price-monthly">
            <span className="amount">{cost_monthly}</span>
            <span className="period">/ {planInfoText[2]}</span>
          </div>
          <p className="plan-card__price-setup">
            {cost_ones} {planInfoText[1]}
          </p>
          {on_sale ? (
            <p className="plan-card__sale">
              {planInfoText[3]} {on_sale}
            </p>
          ) : null}
        </div>

        <a
          className={`btn ${featured ? "btn--primary" : "btn--outline"} btn--block`}
          href={trialUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {planInfoText[0]}
        </a>

        <button
          type="button"
          className="plan-card__toggle"
          aria-expanded={expanded}
          onClick={() => setExpanded(!expanded)}
        >
          {planInfoText[4]}
          <span
            className={`plan-card__chevron${expanded ? " is-up" : ""}`}
            aria-hidden="true"
          />
        </button>

        <ul
          className={`plan-card__features${expanded ? " is-expanded" : ""}`}
        >
          {provides &&
            provides.map((value, index) => {
              const meta = planDescription[index];
              if (!meta) return null;

              const state =
                value === "true" ? "yes" : value === "false" ? "no" : "value";

              return (
                <li key={meta.id} className={`feature feature--${state}`}>
                  <img
                    className="feature__icon"
                    src={state === "no" ? SvgPlanItemFalse : SvgPlanItemTrue}
                    alt=""
                    aria-hidden="true"
                  />
                  <span className="feature__label">{meta.description}</span>
                  {state === "value" ? (
                    <span className="feature__value">{value}</span>
                  ) : null}
                  {meta.info !== "undefined" ? (
                    <Tooltip
                      title={meta.info}
                      placement="top"
                      arrow
                      enterTouchDelay={0}
                      leaveTouchDelay={4000}
                    >
                      <img
                        className="feature__info"
                        src={SvgInformation}
                        alt={ui[resolveLang()].planInfo}
                      />
                    </Tooltip>
                  ) : null}
                </li>
              );
            })}
        </ul>
      </article>
    </Reveal>
  );
};

export default PlanItems;
